import Utils from '../util';
import { ResultRow } from '../models/data-structures/results/result-row.model';
import { AnessaTranslationService } from '../helper/translation/anessa-translation.service';
import { PlotlyTrace } from '../models/results/plotly.model';
import { ReportElement } from './baseline/baseline-summary/baseline-summary.component';
import { CommunicationService } from '../communication/communication.service';
import { ConfiguredToastrService } from '../helper/toastr/configured-toastr.service';
import { take } from 'rxjs/operators';
import { saveAs } from 'file-saver';

export default class ResultsUtils {
  static getTraceFromDataRow(row: number[]) {
    const trace: PlotlyTrace = {
      x: [],
      y: [],
      mode: 'lines',
      type: 'scatter'
    };
    if (Object.keys(row).length < 2) {
      trace['type'] = 'bar';
    }

    row.forEach((val, i) => {
      trace.x.push(i);
      trace.y.push(val);
    });
    return trace;
  }

  static generateResultsSummaryReportCall(reportPack: {elements: ReportElement[], config: Object},
                                          commService: CommunicationService, translationService: AnessaTranslationService,
                                          toastrService: ConfiguredToastrService) {
    commService.fileRequest(reportPack, '/wsasapi/report/generateResultsSummaryReport')
      .pipe(take(1))
      .subscribe(
        res => {
          toastrService.success(translationService.get('SERVICE.REPORT.REPORT_GENERATED'), undefined);
          let fileName = reportPack.config['title'];
          fileName = fileName.replace(/[ &\/\\#,+()$~%.'":*?<>{}]/g, '');
          saveAs(res, fileName);
        }
      );
  }

  static resultDataToResultRow(resultRow: {'RESULTS.DATA.LABEL': string; 'RESULTS.DATA.VALUES': number[]; 'RESULTS.DATA.UNIT': string}
  ): ResultRow {
    const row = new ResultRow();
    row.label = Utils.deepCopy(resultRow['RESULTS.DATA.LABEL']);
    row.values = Utils.deepCopy(resultRow['RESULTS.DATA.VALUES']);
    row.unit = Utils.deepCopy(resultRow['RESULTS.DATA.UNIT']);
    return row;
  }

  static processNameElements(translationService: AnessaTranslationService, nameElements?: string[]) {
    let name = '';
    if (nameElements && nameElements.length > 0) {
      for (const element of nameElements) {
        let translatedElement = element;
        if (element.includes('.')) {
          translatedElement = translationService.get(element);
        }
        if (name === '') {
          name = translatedElement;
          continue;
        }
        name += ', ' + translatedElement;
      }
    }
    return name;
  }
}


// remove when unit db collection rework is complete
export const PeriodUnitMapper: Record<string, string> = {
  '000000000000000000003601': 'UNIT_HACKS.000000000000000000003601',
  '000000000000000000004901': 'UNIT_HACKS.000000000000000000004901',
  '000000000000000000003805': 'UNIT_HACKS.000000000000000000003805',
  '000000000000000000005803': 'UNIT_HACKS.000000000000000000003805',
  '000000000000000000003803': 'UNIT_HACKS.000000000000000000003803',
  '000000000000000000003708': 'UNIT_HACKS.000000000000000000003708',
  '000000000000000000005201': 'UNIT_HACKS.000000000000000000005201',
  '000000000000000000003604': 'UNIT_HACKS.000000000000000000003604',
  '000000000000000000004902': 'UNIT_HACKS.000000000000000000004902',
  '000000000000000000003804': 'UNIT_HACKS.000000000000000000003804',
  '000000000000000000003806': 'UNIT_HACKS.000000000000000000003806',
  '000000000000000000005203': 'UNIT_HACKS.000000000000000000005203',
  '000000000000000000002233': 'UNIT_HACKS.000000000000000000002233',
  '000000000000000000003710': 'UNIT_HACKS.000000000000000000003710',
  '000000000000000000003810': 'UNIT_HACKS.000000000000000000003810',
  '000000000000000000003811': 'UNIT_HACKS.000000000000000000003811',
  '000000000000000000003814': 'UNIT_HACKS.000000000000000000003814',
  '000000000000000000003815': 'UNIT_HACKS.000000000000000000003815',
  '000000000000000000006501': 'UNIT_HACKS.000000000000000000006501',
  '000000000000000000006502': 'UNIT_HACKS.000000000000000000006502',
  '000000000000000000003301': 'UNIT_HACKS.000000000000000000003301',
  '000000000000000000001101': 'UNIT_HACKS.000000000000000000001101',
  '000000000000000000001603': 'UNIT_HACKS.000000000000000000001603',
  '000000000000000000005603': 'UNIT_HACKS.000000000000000000005603',
  '000000000000000000001204': 'UNIT_HACKS.000000000000000000001204',
  '000000000000000000003302': 'UNIT_HACKS.000000000000000000003302',
  '000000000000000000001103': 'UNIT_HACKS.000000000000000000001103',
  '000000000000000000000401': 'UNIT_HACKS.000000000000000000000401',
  '000000000000000000005601': 'UNIT_HACKS.000000000000000000005601',
  '000000000000000000001203': 'UNIT_HACKS.000000000000000000001203',
  '000000000000000000003304': 'UNIT_HACKS.000000000000000000003304',
  '000000000000000000001104': 'UNIT_HACKS.000000000000000000001104',
  '000000000000000000001601': 'UNIT_HACKS.000000000000000000001601',
  '000000000000000000005602': 'UNIT_HACKS.000000000000000000005602',
  '000000000000000000003303': 'UNIT_HACKS.000000000000000000003303',
  '000000000000000000001102': 'UNIT_HACKS.000000000000000000001102',
  '000000000000000000001602': 'UNIT_HACKS.000000000000000000001602',
  '000000000000000000001201': 'UNIT_HACKS.000000000000000000001201',
  '000000000000000000003305': 'UNIT_HACKS.000000000000000000003305',
  '000000000000000000005604': 'UNIT_HACKS.000000000000000000005604',
  '000000000000000000001202': 'UNIT_HACKS.000000000000000000001202',
  '000000000000000000003818': 'UNIT_HACKS.000000000000000000003818',
  '000000000000000000003821': 'UNIT_HACKS.000000000000000000003821',
  '000000000000000000003307': 'UNIT_HACKS.000000000000000000003307',
  '000000000000000000000701': 'UNIT_HACKS.000000000000000000000701',
  '000000000000000000000703': 'UNIT_HACKS.000000000000000000000703',
  '000000000000000000004903': 'UNIT_HACKS.000000000000000000004903',
  '000000000000000000003306': 'UNIT_HACKS.000000000000000000003306'
}
